import * as React from 'react';

function Beers1(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={14} height={19} viewBox="0 0 14 19" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.434.637A1.123 1.123 0 0012.59.25H1.375C1.059.25.742.39.531.637c-.21.21-.316.527-.281.808l1.125 15.75A1.12 1.12 0 002.5 18.25h8.965a1.12 1.12 0 001.125-1.055l1.125-15.75a1.004 1.004 0 00-.281-.808zm-2.18 4.113H2.71L2.57 2.5h8.824l-.141 2.25z"
        fill="#BDBDBD"
      />
    </svg>
  );
}

export default Beers1;
